import { createFileRoute } from '@tanstack/react-router';

import { useFieldLayout } from '../hooks/useMedia';
import { PerDiemComponent } from '../modules/ComponentsLibrary/PerDiem';
import { PerDiemPhone } from '../modules/ComponentsLibrary/PerDiem/phone/PerDiemPhone';

export const Route = createFileRoute('/perdiem')({
  component: RouteComponent,
});

function RouteComponent() {
  // Phones and tablets get the phone layout; the Payroll embed of the desktop page stays desktop.
  const isFieldLayout = useFieldLayout();
  return isFieldLayout ? <PerDiemPhone /> : <PerDiemComponent />;
}
